import React, { useContext } from 'react';
import { Menu, Spin } from 'antd';
import HeaderDropdown from '../HeaderDropdown';
import styles from './index.less';
import { AuthContext } from '../Auth/Auth';
import { useHistory } from 'react-router';
import { useModalState } from 'hooks/useModalState';
import MyProfileModal from './MyProfile/MyProfileModal';
import ISettings from 'icons/ISettings';
import ILogout from 'icons/ILogout';
import IUser from 'icons/IUser';
import { EditOutlined, LoadingOutlined } from '@ant-design/icons';
import ModalControllerNV from 'components/ModalControllerNV';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import { API_URLS } from 'utils/config';

const AvatarDropdown = (props: any) => {
  const URL = API_URLS.AUTHENTICATION_SERVICE;


  const history = useHistory();
  const myProfileModal = useModalState();
  const onLogoutClick = (event: any, context: any) => {

    context.setToken(''); 
    localStorage.clear();  
    history.push('/login'); 
    localStorage.setItem('changepassword', ''); 

  };
  // const onLogoutClick = async(event: any, context: any) => {
  //   const token = localStorage.getItem('token');

  //   if (!token) {
  //     throw new Error('Token non trouvé');
  //   }
  
  //   try {
  //     // Logout
  //     const response = await fetch(`${URL}/log_out`, {
  //       method: 'POST',
  //       headers: {
  //         'Authorization': `Bearer ${token}`,
  //         'Content-Type': 'application/json',
  //       },
  //     });
  
  //     if (!response.ok) {
  //       throw new Error('Échec de la déconnexion');
  //     }

  //     notification.info({message: 'Déconnexion réussie'})
  
  //     const result = await response.json();
  
  //     context.setToken(''); 
  //     localStorage.clear();  
  //     // history.push('/login'); 
  //     localStorage.setItem('changepassword', ''); 
      
  //   } catch (error) {
  //     console.error('Erreur lors de la déconnexion:', error);
  //   }
  // };
  const { isInspect, setInspectMode } = useContext(AuthContext);

  const menuHeaderDropdown = (
    <AuthContext.Consumer>
      {(context) => (
        <>
          <Menu className={styles.menu} selectedKeys={[]}>
            {!props.isExcludedFromLayout && localStorage.getItem('userrole') !== 'BROKER' && (
              <Menu.Item key="settings" onClick={myProfileModal.open}>
                <ISettings />
                Account settings
              </Menu.Item>
            )}
            {(localStorage.getItem('userrole') === 'ADMIN') && (
              <>
                <Menu.Divider />
                <Menu.Item
                  key="inspect"
                  onClick={() => {
                    setInspectMode(!isInspect);
                  }}
                >
                  {isInspect ? (
                    <LoadingOutlined style={{ fontSize: 21 }} />
                  ) : (
                    <EditOutlined style={{ fontSize: 21 }} />
                  )}
                  Inspect Mode
                </Menu.Item>
              </>
            )}

            {localStorage.getItem('userrole') === 'WHOLESALE' && (
              <>
                <Menu.Divider />

                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <a
                      onClick={() => {
                        setVisible(true);
                      }}
                    >
                      <Menu.Item icon={<IUser />} key="profile">
                        My Profile
                      </Menu.Item>
                    </a>
                  )}
                  modal={({ setVisible, visible }) => (
                    <ThirdPartyModal
                      tpId={Number(localStorage.getItem('tpid')) ?? 0}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title={localStorage.getItem('name') ?? ''}
                      iscreate={false}
                    />
                  )}
                />
              </>
            )}
            <Menu.Divider />
            <Menu.Item
              key="logout"
              onClick={(event) => onLogoutClick(event, context)}
            >
              <ILogout />
              Logout
            </Menu.Item>
          </Menu>
          <MyProfileModal
            visible={myProfileModal.visible}
            onCancel={myProfileModal.close}
          />
        </>
      )}
    </AuthContext.Consumer>
  );
  return localStorage.getItem('username') ? (
    <HeaderDropdown
      overlay={menuHeaderDropdown}
      overlayClassName="header-dropdown"
    >
      <span className={`${styles.action} ${styles.account}`}>
        <IUser />
        <span className={styles.name}>
          {localStorage.getItem('surname') + ' ' + localStorage.getItem('name')}
        </span>
      </span>
    </HeaderDropdown>
  ) : (
    <Spin
      size="small"
      style={{
        marginLeft: 8,
        marginRight: 8,
      }}
    />
  );
};

export default AvatarDropdown;
